<template>
  <!--更换验证手机号-身份验证-->
  <el-dialog
    :title="$t('salesCenter.markSupervisorInfo')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :width="$getColumnWidth(750, 920) + 'px'"
    custom-class="MyDialog"
    append-to-body
    @close="close"
    >
    <el-form ref="duxueForm" :model="fromData" :rules="duxueFormRules" :label-width="$getColumnWidth(110, 200) + 'px'">
      <el-form-item :label="$t('salesCenter.supervisorStatusLabel')" prop="supervisorStatus">
        <el-radio-group v-model="fromData.supervisorStatus">
          <el-radio v-for="item in duxueStatusList" :key="item.id"
          :label="item.id">{{item.name}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <p v-if="fromData.supervisorStatus==6158005" class="tips">{{ $t('salesCenter.markSupervisorNoneDetailTip') }}</p>
      <el-form-item :label="$t('salesCenter.analystLabel')" prop="teacherIds" v-if="showTeacherSelect">
        <el-col :span="22">
          <el-select v-model="fromData.teacherIds" multiple :placeholder="$t('salesCenter.pleaseSelectAnalyst')"
          @change="teacherIdsChange"
          style="width: 100%;">
            <el-option
              v-for="(item,index) in teacherList"
              :value="item.teacherId"
              :label="item.teacherName"
              :key="index"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-tooltip
            placement="top-end"
            :content="$t('salesCenter.unsupervisedStudentDataTipDetail')"
          >
            <i class="el-icon-question" :style="{ color: '#4A83E8',fontSize:'16px' }"></i>
          </el-tooltip>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('salesCenter.supervisorValidDateLabel')" prop="time" v-if="fromData.supervisorStatus==6158002 || fromData.supervisorStatus==6158003">
        <el-col :span="22">
          <el-date-picker
          style="width: 100%;"
              v-model="fromData.time"
              type="daterange"
              :range-separator="$t('app.to')"
              :unlink-panels="true"
              :start-placeholder="$t('app.startDatePlaceholder')"
              :end-placeholder="$t('app.endDatePlaceholder')"
              value-format="yyyy-MM-dd"
              :picker-options="duxuePickerOptions"
              @change="changeTime"
              clearable
            >
            </el-date-picker>
        </el-col>
        <el-col :span="2">
          <el-tooltip
            placement="top-end"
            :content="$t('salesCenter.supervisorExpireNextDayTip')"
          >
            <i class="el-icon-question" :style="{ color: '#4A83E8',fontSize:'16px' }"></i>
          </el-tooltip>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('salesCenter.supervisorApplyOrderLabel')" prop="supervisorApplyOrderId" v-if="showSupervisorApplyOrderSelect">
        <el-col :span="22">
          <el-select
            v-model="fromData.supervisorApplyOrderId"
            :placeholder="$t('salesCenter.pleaseSelectSupervisorApplyOrder')"
            :loading="supervisorApplyOrderLoading"
            :disabled="supervisorApplyBindLocked"
            filterable
            style="width: 100%;"
            @change="handleSupervisorApplyOrderChange"
          >
            <el-option
              v-for="item in supervisorApplyOrderList"
              :key="item.applyOrderId"
              :label="item.displayText || item.applyNo"
              :value="item.applyOrderId"
            ></el-option>
          </el-select>
          <p v-if="supervisorApplyBindLocked" class="bind-tip">{{ $t('salesCenter.supervisorApplyBindLockedTip') }}</p>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('salesCenter.supervisorStoreLabel')" prop="supervisorShop" v-if="showSupervisorStoreSelect">
        <el-col :span="22">
          <el-select v-model="fromData.supervisorShop" :placeholder="$t('salesCenter.pleaseSelectSupervisorStore')" class="store-select" multiple :multiple-limit="5">
            <el-option 
              v-for="item in supervisorShopList" 
              :key="item.storeId" 
              :label="`${item.detail}`" 
              :value="item.storeId">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('salesCenter.remarkLabelWithColon')">
        <el-col :span="22">
          <el-input type="textarea" maxlength="100" v-model="fromData.supervisorRemark" show-word-limit></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <div v-if="!datas.accountId" style="max-height: 300px; overflow: auto">
      <MyTable :titleData="allocatedCustomer_title" :tableData="studentInfo">
      </MyTable>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close()" :disabled="submitLoading">{{ $t('app.auto_576_be030eaf') }}</el-button>
      <el-button type="primary" @click="submitChange" :loading="submitLoading">{{ $t('app.auto_68_3c08da52') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDictionaryListI18n, updateStudentSupervisor } from '@/api/basicApi';
import { resolveTitleDataI18n } from "@/i18n/formI18n";
import { batchAddStudents } from "@/api/studentProfile";
import { getStudentInfoByStudentIds, queryAgentOpeningStoreList } from "@/api/OrderManage";
import { getCheckTeachers } from "@/api/ShiTin";
import { queryStudentUnconsumedSupervisorApplyOrders } from "@/api/SupervisorApplyOrder";
import MyTable from "@/components/table.vue";
import moment from "moment";
import { debounce} from "@/util/util";
import { getDictionaryName } from "@/i18n/dictionary";
import LoginUserHelper from "@/util/LoginUserHelper";
export default {
  data() {
    return {
      fromData: {
        supervisorStatus: "",
        teacherIds: [],
        time:[],
        supervisorRemark:'',
        supervisorShop:[],
        supervisorApplyOrderId:'',
        supervisorApplyNo:'',
      },
      allocatedCustomer_result:{},
      studentInfo:[],
      submitLoading: false, // 提交按钮loading状态
      duxueStatusList:[],
      teacherList:[],
      supervisorShopList:[],
      supervisorApplyOrderList:[],
      supervisorApplyOrderLoading: false,
      supervisorApplyBindLocked: false,
      dialogVisible: this.isShowDuxueFlagDialog,
      isStateNum:1,
      isSendCode: false,
      codeCountDown: -1,
    }
  },
  props: {
    datas: {
      type: Object,
      default: () => {},
    },
    isShowDuxueFlagDialog: {
      type: Boolean,
      default: false,
    },
    isShowOpen: {
      type: Boolean,
      default: false,
    },
    allocatedCustomers:{
      type: Array,
      default: () => {
        return []
      }
    },
    isBatchAddStudent: {
      type: Boolean,
      default: false,
    },
    // 是否是自定义分析师，从其他页面传入
    selfTeacherId: {
      type: Number|String,
      default: '',
    },
  },
  computed: {
    isDirectStore() {
      const userInfo = LoginUserHelper.getUserInfo() || {};
      return Number(userInfo.isDirectStore) === 1;
    },
    isSupervisorApplyStatus() {
      return this.fromData.supervisorStatus == 6158002 || this.fromData.supervisorStatus == 6158003;
    },
    currentStudentRows() {
      return this.resolveCurrentStudentRows();
    },
    currentAccountId() {
      const rows = this.currentStudentRows;
      if (!rows || rows.length !== 1) {
        return "";
      }
      return this.resolveRowAccountId(rows[0]);
    },
    showSupervisorApplyOrderSelect() {
      return !this.isBatchAddStudent && this.isDirectStore && this.isSupervisorApplyStatus && this.currentStudentRows.length === 1;
    },
    showSupervisorStoreSelect() {
      if (this.$i18n && this.$i18n.locale === "en-US") return false;
      return this.fromData.supervisorStatus && this.fromData.supervisorStatus != 6158005 && this.supervisorShopList.length > 0;
    },
    // 是否显示分析师选择器
    showTeacherSelect() {
      const { supervisorStatus } = this.fromData;
      const excludedStatuses = [6158001, 6158005];
      return supervisorStatus && 
             !excludedStatuses.includes(supervisorStatus) && 
             !this.selfTeacherId;
    },
    allocatedCustomer_title() {
      return [
        {
          label: this.$t('app.auto_346_8759d587'),
          prop: "studentName",
          key: "studentId",
          width: 160,
          type: "colorText",
          noUrl: true,
        },
        {
          label: this.$t('app.auto_347_221bceee'),
          prop: "stageGradeDesc",
          key: "stageGradeDesc",
          width: 160,
        },
        {
          label: this.$t('app.auto_348_7338083d'),
          prop: "accountUser",
          key: "accountUser",
          width: 160,
        },
        {
          label: this.$t('app.auto_349_d9ef97f6'),
          prop: "serverPeople",
          key: "serverPeople",
          width: 160,
        },
      ];
    },
    duxueFormRules() {
      const vm = this;
      return {
        teacherIds: [
          { required: true, message: this.$t('salesCenter.pleaseSelectAnalyst'), trigger: 'change' }
        ],
        time: [
          {
            validator(rule, value, callback) {
              if (!value || !value[0] || !value[1]) {
                return callback(new Error(vm.$t('app.auto_344_b8289acd')));
              }
              callback();
            },
            required: true,
            trigger: 'change'
          }
        ],
        supervisorStatus: [
          { required: true, message: this.$t('salesCenter.craaPleaseSelectStatus'), trigger: 'change' }
        ],
        supervisorShop: [
          {
            required: true,
            validator(rule, value, callback) {
              if (!vm.showSupervisorStoreSelect) {
                return callback();
              }
              if (vm.fromData.supervisorStatus != 6158005 && (!value || (Array.isArray(value) && value.length === 0))) {
                return callback(new Error(vm.$t('salesCenter.pleaseSelectSupervisorStore')));
              }
              callback();
            },
            trigger: 'change'
          }
        ],
        supervisorApplyOrderId: [
          {
            required: true,
            validator(rule, value, callback) {
              if (vm.isBatchAddStudent || !vm.isDirectStore || !vm.isSupervisorApplyStatus) {
                return callback();
              }
              if (vm.currentStudentRows.length !== 1) {
                return callback(new Error(vm.$t('salesCenter.directStoreSupervisorApplyBatchTip')));
              }
              if (!value) {
                return callback(new Error(vm.$t('salesCenter.pleaseSelectSupervisorApplyOrder')));
              }
              callback();
            },
            trigger: 'change'
          }
        ],
      };
    },
    duxuePickerOptions() {
      const vm = this;
      return {
        // Keep shortcut wording explicit: 7 days / 1, 3, 6, 12 months.
        shortcuts: [{
          text: vm.$i18n.locale === 'en-US' ? '7 days' : '7天',
          onClick(picker) {
            console.log(picker.minVisibleDate,9999)
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: vm.$i18n.locale === 'en-US' ? '1 month' : `1${vm.$t('serviceCenter.monthsUnit')}`,
          onClick(picker) {
            console.log(moment(),moment(picker.minVisibleDate),999)
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(new Date(moment(picker.minVisibleDate || new Date()).add(1,'month').format("YYYY-MM-DD")).getTime());
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: vm.$i18n.locale === 'en-US' ? '3 months' : `3${vm.$t('serviceCenter.monthsUnit')}`,
          onClick(picker) {
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(new Date(moment(picker.minVisibleDate || new Date()).add(3,'month').format("YYYY-MM-DD")).getTime());
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: vm.$i18n.locale === 'en-US' ? '6 months' : `6${vm.$t('serviceCenter.monthsUnit')}`,
          onClick(picker) {
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(new Date(moment(picker.minVisibleDate || new Date()).add(6,'month').format("YYYY-MM-DD")).getTime());
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: vm.$i18n.locale === 'en-US' ? '12 months' : `12${vm.$t('serviceCenter.monthsUnit')}`,
          onClick(picker) {
            const end = new Date();
            const start = picker.minVisibleDate ? new Date(picker.minVisibleDate) : new Date();
            end.setTime(new Date(moment(picker.minVisibleDate || new Date()).add(12,'month').format("YYYY-MM-DD")).getTime());
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          let minTime = new Date('2022-01-01').getTime();
          return minTime > time.getTime();
        }
      };
    },
    titleDataI18n() {
      return resolveTitleDataI18n(this.titleData, 'common', this.$t.bind(this));
    },
  },
  watch: {
    "fromData.supervisorStatus"() {
      this.handleSupervisorStatusChange();
    },
    isShowDuxueFlagDialog: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true
    },
    isShowOpen: {
      handler(newVal) {
        if (newVal) {
          this.dialogVisible = true;
        }
      },
      immediate: true
    },
  },
  components:{
    MyTable,
  },
  mounted(){
    this.initData()
    this.getStudentInfoByStudentIds()
    if(this.datas && this.datas.accountId){
      const {supervisorStatus,teacherIds,supervisorStartTime,supervisorEndTime,supervisorRemark,storeIds = []} = this.datas
      this.fromData = {
        supervisorStatus: supervisorStatus==6158001?'':(supervisorStatus || ''),
        teacherIds: teacherIds || [],
        time: [supervisorStartTime||'',supervisorEndTime||''],
        supervisorStartTime:supervisorStartTime || '',
        supervisorEndTime: supervisorEndTime || '',
        supervisorRemark: supervisorRemark || '',
        supervisorShop: storeIds || [],
        supervisorApplyOrderId: '',
        supervisorApplyNo: '',
      }
      if(teacherIds){
        this.teacherIdsChange(teacherIds)
      }
    }
    this.$nextTick(() => {
      this.loadSupervisorApplyOrders();
    });
  },
  methods: {
    resolveCurrentStudentRows() {
      if (this.datas && Object.keys(this.datas).length && (this.datas.accountId || this.datas.studentId)) {
        return [this.datas];
      }
      return this.allocatedCustomers || [];
    },
    resolveRowAccountId(row) {
      if (!row) {
        return "";
      }
      return row.accountId || row.account_id || "";
    },
    resolveRowStudentId(row) {
      if (!row) {
        return "";
      }
      return row.studentId || row.student_id || "";
    },
    resolveCurrentStudentIds() {
      return this.resolveCurrentStudentRows()
        .map(item => this.resolveRowStudentId(item))
        .filter(item => item !== "" && item !== undefined && item !== null);
    },
    async initData() {
      await getDictionaryListI18n({ typeId: "6158" }, this.$i18n.locale).then(ret => {
        if (ret.code === 0) {
          this.duxueStatusList = ret.data.filter(item=> {
            return item.id != 6158001
          });
        }
      });
      await getCheckTeachers({
        accountStatus: 6026003,
      }).then((res) => {
        if (res.code === 0) {
          this.teacherList = res.data || [];
        }
      });
      if (this.$i18n && this.$i18n.locale === "en-US") {
        this.supervisorShopList = [];
        return;
      }
      queryAgentOpeningStoreList({}).then((res) => {
        if (res.code === 0) {
          this.supervisorShopList = res.data || [];
        } else {
          this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('app.failed'));
        }
      });
    },
    changeTime(value) {
      if (value && value.length > 1) {
        this.fromData.supervisorStartTime = value[0];
        this.fromData.supervisorEndTime = value[1];
      } else {
        this.fromData.supervisorStartTime = "";
        this.fromData.supervisorEndTime = "";
      }
    },
    handleSupervisorStatusChange() {
      if (!this.isSupervisorApplyStatus) {
        this.clearSupervisorApplyOrder();
        return;
      }
      this.loadSupervisorApplyOrders();
    },
    clearSupervisorApplyOrder() {
      this.supervisorApplyOrderList = [];
      this.supervisorApplyBindLocked = false;
      this.fromData.supervisorApplyOrderId = "";
      this.fromData.supervisorApplyNo = "";
    },
    loadSupervisorApplyOrders() {
      if (this.isBatchAddStudent || !this.isDirectStore || !this.isSupervisorApplyStatus) {
        this.clearSupervisorApplyOrder();
        return;
      }
      if (this.currentStudentRows.length !== 1 || !this.currentAccountId) {
        this.clearSupervisorApplyOrder();
        return;
      }
      this.supervisorApplyOrderLoading = true;
      queryStudentUnconsumedSupervisorApplyOrders({
        accountId: this.currentAccountId
      }).then(res => {
        this.supervisorApplyOrderLoading = false;
        if (res.code !== 0) {
          this.clearSupervisorApplyOrder();
          this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('app.failed'));
          return;
        }
        this.supervisorApplyOrderList = res.data || [];
        const lockedItem = this.supervisorApplyOrderList.find(item => item.lockedFlag);
        if (lockedItem) {
          this.supervisorApplyBindLocked = true;
          this.fromData.supervisorApplyOrderId = lockedItem.applyOrderId;
          this.fromData.supervisorApplyNo = lockedItem.applyNo;
          this.$nextTick(() => this.$refs.duxueForm && this.$refs.duxueForm.clearValidate('supervisorApplyOrderId'));
          return;
        }
        this.supervisorApplyBindLocked = false;
        if (this.supervisorApplyOrderList.length === 1) {
          const onlyItem = this.supervisorApplyOrderList[0];
          this.fromData.supervisorApplyOrderId = onlyItem.applyOrderId;
          this.fromData.supervisorApplyNo = onlyItem.applyNo;
          this.$nextTick(() => this.$refs.duxueForm && this.$refs.duxueForm.clearValidate('supervisorApplyOrderId'));
        } else if (!this.supervisorApplyOrderList.some(item => item.applyOrderId === this.fromData.supervisorApplyOrderId)) {
          this.fromData.supervisorApplyOrderId = "";
          this.fromData.supervisorApplyNo = "";
        }
      }).catch(() => {
        this.supervisorApplyOrderLoading = false;
        this.clearSupervisorApplyOrder();
        this.$message.error(this.$t('salesCenter.operationFail'));
      });
    },
    handleSupervisorApplyOrderChange(value) {
      const item = this.supervisorApplyOrderList.find(order => order.applyOrderId === value);
      this.fromData.supervisorApplyNo = item ? item.applyNo : "";
    },
    teacherIdsChange(data){

    },
    codeTimeKeep() {
      this.codeTimer = setInterval(() => {
        if (this.codeCountDown < 0) {
          clearInterval(this.codeTimer);
          return;
        }
        this.codeCountDown -= 1;
      }, 1000);
    },
    resetTimer() {
      if (this.codeTimer) {
        clearInterval(this.codeTimer);
      }
      this.codeCountDown = -1;
      this.isSendCode = false;
    },
    /** 阶段(6003) + 年级(6004) 字典文案，与接口 stage、grade 字段对应 */
    formatStageGradeDisplay(row) {
      const loc = this.$i18n && this.$i18n.locale;
      let stageText = "";
      let gradeText = "";
      if (row.stage !== undefined && row.stage !== null && row.stage !== "") {
        stageText = getDictionaryName("6003", row.stage, loc) || "";
      }
      if (row.grade !== undefined && row.grade !== null && row.grade !== "") {
        gradeText = getDictionaryName("6004", row.grade, loc) || "";
      }
      if (!stageText && row.stageName) stageText = String(row.stageName);
      if (!gradeText && row.gradeName) gradeText = String(row.gradeName);
      const parts = [stageText, gradeText].filter(Boolean);
      return parts.length ? parts.join("/") : "-";
    },
    data1Change(data1,data2){
      console.log(data1,data2)
    },
    data2Change(){

    },
    submitChange: debounce(function() {
      this.submitLoading = true;
      if (this.isBatchAddStudent) { // 添加学生
        this.batchAddStudent();
      } else {// 修改督学状态
        this.updateStudentSupervisor();
      }
    }, 500, true),
    getStudentInfoByStudentIds() {
      let stu_ids = this.resolveCurrentStudentIds();
      this.allocatedCustomer_result["ids"] = stu_ids;
      if (!stu_ids.length) {
        this.studentInfo = [];
        return;
      }
      getStudentInfoByStudentIds(stu_ids).then((res) => {
        if (res.code === 0) {
          let options = res.data;
          if (this.isBatchAddStudent) { // 如果是批量添加学生，只显示正式学员
            options = options.filter(item => item.machineFlag == 1);
          }
          options.map((item) => {
            item["stageGradeDesc"] = this.formatStageGradeDisplay(item);
          });
          this.studentInfo = options;
        }
      });
    },
    // 提交信息
    updateStudentSupervisor() {
      this.$refs.duxueForm.validate((valid) => {
        if(!valid){
          this.submitLoading = false;
          return
        }
        let params = {
          studentIds: this.allocatedCustomer_result.ids && this.allocatedCustomer_result.ids.length
            ? this.allocatedCustomer_result.ids
            : this.resolveCurrentStudentIds(),
          supervisorStatus:this.fromData.supervisorStatus,
          supervisorStartTime:this.fromData.supervisorStartTime,
          supervisorEndTime:this.fromData.supervisorEndTime,
          supervisorRemark:this.fromData.supervisorRemark,
        }
        if (this.showSupervisorStoreSelect) {
          params.storeIds = this.fromData.supervisorShop;
        }
        if (!this.selfTeacherId) {
          params.teacherIds = this.fromData.teacherIds;
        } else {
          params.notUnbindTeacher = 1;
        }
        if (this.isDirectStore && this.isSupervisorApplyStatus) {
          if (this.currentStudentRows.length !== 1) {
            this.submitLoading = false;
            this.$message.warning(this.$t('salesCenter.directStoreSupervisorApplyBatchTip'));
            return;
          }
          if (!this.currentAccountId) {
            this.submitLoading = false;
            this.$message.warning(this.$t('salesCenter.studentAccountIdRequired'));
            return;
          }
          params.accountIds = [String(this.currentAccountId)];
          params.supervisorApplyOrderId = this.fromData.supervisorApplyOrderId;
          params.supervisorApplyNo = this.fromData.supervisorApplyNo;
          params.campusId = LoginUserHelper.getUserInfo().campusId;
        }
        updateStudentSupervisor(params).then(res=>{
          this.submitLoading = false;
          if(res.code === 0){
            this.$message.success(this.$t('salesCenter.markSuccess'))
            this.close('flash')
          }else{
            this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('app.failed'));
          }
         }).catch(err => {
          this.submitLoading = false;
          this.$message.error(this.$t('salesCenter.operationFail'));
         })
      })
    },
    // 批量添加学生
    batchAddStudent() {
      this.$refs.duxueForm.validate((valid) => {
        if(!valid){
          this.submitLoading = false;
          return
        }
        let params = {
          studentIdList: this.allocatedCustomer_result.ids && this.allocatedCustomer_result.ids.length
            ? this.allocatedCustomer_result.ids
            : this.resolveCurrentStudentIds(),
          supervisorStatus:this.fromData.supervisorStatus,
          teacherUserId: this.selfTeacherId,
          supervisorStartTime:this.fromData.supervisorStartTime,
          supervisorEndTime:this.fromData.supervisorEndTime,
          supervisorRemark:this.fromData.supervisorRemark,
          checkDirectStoreAddSupervisorStudent: this.isBatchAddStudent,
        }
        if (this.showSupervisorStoreSelect) {
          params.storeIds = this.fromData.supervisorShop;
        }
        batchAddStudents(params).then(res=>{
          this.submitLoading = false;
          if(res.code === 0){
            this.$message.success(this.$t('salesCenter.addSuccess'))
            this.close('flash')
          }else{
            this.$message.error(this.$getCodeMessage(res.code, res.message, res.messageArgs) || this.$t('app.failed'));
          }
         }).catch(err => {
          this.submitLoading = false;
          this.$message.error(this.$t('salesCenter.operationFail'));
         })
      })
    },
    close(flash) {
      this.dialogVisible = false;
      this.$emit('closeDuxueFlagDialog',flash);
    }
  },
}
</script>

<style scoped lang="scss">
.tips{
  margin: -20px 100px 10px;
  color: #e6a23c;
}
.bind-tip{
  margin: 6px 0 0;
  line-height: 18px;
  color: #909399;
  font-size: 12px;
}
.MyDialog{
  .store-select{
    width: 100%;
  }
}
</style>
